import { categoryLabel } from "../../data/portfolio";

const FACTS = [
  ["Plaats", (p) => p.plaats], ["Uitvoeringsjaar", (p) => p.year], ["Type woning", (p) => p.woningtype],
  ["Productcategorie", (p) => p.categories?.map(categoryLabel).join(", ")], ["Materiaal", (p) => p.specs?.materiaal],
  ["Kozijnmerk", (p) => p.specs?.merk], ["Profielsysteem", (p) => p.specs?.systeem],
  ["Kleur", (p) => [p.specs?.kleur, p.specs?.ral && `RAL ${p.specs.ral.replace(/^RAL\s*/i, "")}`].filter(Boolean).join(" · ")],
  ["Glas", (p) => p.specs?.glas], ["Aantal kozijnen", (p) => p.specs?.aantal], ["Opening", (p) => p.specs?.opening],
  ["Uitvoering", (p) => p.specs?.uitvoering], ["Uitvoeringsduur", (p) => p.specs?.duur],
];

export const projectFacts = (p) => FACTS.map(([k, f]) => [k, f(p)]).filter(([, v]) => v && String(v).trim());

export const ProjectFacts = ({ p }) => {
  const facts = projectFacts(p);
  if (!facts.length) return null;
  return (
    <div className="card p-6" data-testid="project-facts">
      <h2 className="text-[13px] font-semibold uppercase tracking-[0.14em] text-gold">Projectgegevens</h2>
      <dl className="mt-4 divide-y divide-slate-100">
        {facts.map(([k, v]) => (
          <div key={k} className="grid grid-cols-5 gap-3 py-2.5">
            <dt className="col-span-2 text-[14px] text-slate-500">{k}</dt>
            <dd className="col-span-3 text-[14.5px] font-medium text-ink">{v}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
